import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import api from '../../api/auth';

const Reports = () => {
  const { user } = useAuth();
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchReports();
  }, []);

  const fetchReports = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await api.get('/parent/reports', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setReports(response.data);
    } catch (error) {
      console.error('Erreur:', error);
    } finally {
      setLoading(false);
    }
  };

  const downloadReport = async (reportId) => {
    try {
      const token = localStorage.getItem('token');
      const response = await api.get(`/parent/reports/${reportId}/download`, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: 'blob'
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `bulletin_${reportId}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error('Erreur:', error);
      alert('Erreur lors du téléchargement');
    }
  };

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-[#2C3E50]">📄 Bulletins</h1>
      <p className="text-gray-500">Consultez et téléchargez les bulletins de vos enfants</p>

      {loading ? (
        <div className="text-center py-8">Chargement...</div>
      ) : reports.length === 0 ? (
        <div className="bg-white rounded-xl shadow-md p-8 text-center">
          <p className="text-gray-500">Aucun bulletin disponible</p>
        </div>
      ) : (
        <div className="space-y-4">
          {reports.map((report) => (
            <div key={report.id} className="bg-white rounded-xl shadow-md p-4 flex justify-between items-center">
              <div>
                <h3 className="font-semibold text-[#2C3E50]">{report.title}</h3>
                <p className="text-sm text-gray-500">{report.child_name} - {report.class_name}</p>
                <p className="text-sm text-gray-500">Moyenne: {report.average}/20 - Rang: {report.rank}</p>
              </div>
              <div className="flex space-x-3">
                <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                  report.status === 'published' ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'
                }`}>
                  {report.status === 'published' ? 'Publié' : 'En attente'}
                </span>
                {report.status === 'published' && (
                  <button
                    onClick={() => downloadReport(report.id)}
                    className="bg-[#E67E22] text-white px-4 py-2 rounded-lg hover:bg-[#D35400] transition text-sm"
                  >
                    📥 PDF
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Reports;